import React from 'react'
import Button from './../Button/Button'
import './TextBlock.css'

const TextBlock = props => {
  let button = props.button
  return (
    <div className="fmbm-text-block">
      <div className="fmbm-text-block__header">
        <p>{props.headerText}</p>
      </div>
      <div className="fmbm-text-block__body">
        <p>{props.bodyText}</p>
      </div>
      <Button
        href={button.href}
        buttonText={button.text}
        style={{ backgroundColor: button.color }}
      />
    </div>
  )
}

export default TextBlock



// WEBPACK FOOTER //
// ./src/Components/TextBlock/TextBlock.js